import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import {I18nextProvider} from "react-i18next";
import {CookiesProvider} from 'react-cookie';

import App from './App';
import i18n from "./i18n";

ReactDOM.render(
    <CookiesProvider>
        <BrowserRouter>
            <I18nextProvider i18n={i18n}>
                <App/>
            </I18nextProvider>
        </BrowserRouter>
    </CookiesProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
